import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class BurnedHouseSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.BURNED_HOUSE;
}

export default BurnedHouseSalvageableTileEntity;
